// @flow
import {
  phoneScreenMaxWidth,
  largeScreenMinWidth,
  extraLargeScreenMinWidth,
  remBase,
  yPadding,
  xPaddingDefault,
  xPaddingPhone,
  xPaddingXL,
  textColor
} from '../styles/style-constants';

export function getPhoneMediaQueriedStyle(styles: Object, maxWidth: number = phoneScreenMaxWidth) {
  return {
    [`@media screen and (max-width: ${maxWidth})`]: {
      ...styles
    }
  };
}

export function getLargeMediaQueriedStyle(styles: Object, minWidth: number = largeScreenMinWidth) {
  return {
    [`@media screen and (min-width: ${minWidth})`]: {
      ...styles
    }
  };
}

export function getXLMediaQueriedStyle(styles: Object, minWidth: number = extraLargeScreenMinWidth) {
  return {
    [`@media screen and (min-width: ${minWidth})`]: {
      ...styles
    }
  };
}

export function convertPixelsToRem(px: number | string) {
  const pixelSize = parseInt(px, 10);

  if (Number.isNaN(pixelSize) || String(px).endsWith('%')) {
    return px;
  }

  return pixelSize === 0 ? '0' : `${pixelSize / remBase}rem`;
}

export function remCalc(...pxSizes: Array<number | string>): string {
  if (pxSizes.length > 4) {
    throw new Error(`CSS shortcuts have a max of 4 sizes. Recieved: ${pxSizes.length}`);
  }

  return pxSizes.map(convertPixelsToRem).join(' ');
}

export const sectionPaddingStyle = {
  padding: remCalc(yPadding, xPaddingDefault),
  ...getPhoneMediaQueriedStyle({
    padding: remCalc(yPadding / 2, xPaddingPhone)
  })
  // ...getXLMediaQueriedStyle({
  //   padding: remCalc(yPadding, xPaddingXL)
  // })
};

export const xPaddingStyle = {
  padding: remCalc(0, xPaddingDefault),
  ...getPhoneMediaQueriedStyle({
    padding: remCalc(0, xPaddingPhone)
  }),
  ...getXLMediaQueriedStyle({
    padding: remCalc(0, xPaddingXL)
  })
};

export const sectionTitleStyle = {
  fontSize: remCalc(40),
  fontHeight: remCalc(48),
  fontWeight: 700,
  letterSpacing: remCalc(2),
  ...getPhoneMediaQueriedStyle({
    fontSize: remCalc(25),
    fontHeight: remCalc(30)
  })
};

export const sectionDescriptionStyle = {
  fontSize: remCalc(24),
  lineHeight: remCalc(36),
  fontWeight: 300,
  color: textColor,
  ...getPhoneMediaQueriedStyle({
    fontSize: remCalc(16),
    lineHeight: remCalc(19)
  })
};

export function getPropertyStyle(cssProperty: string, defaultValue: any, phoneValue?: any, xl?: any) {
  let styleObject = {
    [cssProperty]: defaultValue
  };

  if (phoneValue) {
    styleObject = { ...styleObject, ...getPhoneMediaQueriedStyle({ [cssProperty]: phoneValue }) }
  }

  if (xl) {
    styleObject = { ...styleObject, ...getXLMediaQueriedStyle({ [cssProperty]: xl }) }
  }

  return styleObject;
}

export function getBottomMarginStyle (yMarginLarge: number, yMarginPhone?: number, yMarginXL?: number): Object {
  let styleObject = {
    marginBottom: remCalc(yMarginLarge)
  };

  if (yMarginPhone) {
    styleObject = { ...styleObject, ...getPhoneMediaQueriedStyle({ marginBottom: remCalc(yMarginPhone) }) }
  }

  if (yMarginXL) {
    styleObject = { ...styleObject, ...getXLMediaQueriedStyle({ marginBottom: remCalc(yMarginXL) }) }
  }

  return styleObject;
}



// WEBPACK FOOTER //
// ./src/util/style-util.js